import axios, { AxiosResponse, AxiosError } from 'axios';

export interface ReportingData 
{
    path: string;
    terminal: string;
    appMode: string;
    mobile: boolean;
}

export class Reporting
{
    private baseUrl: string;

    constructor(baseUrl: string)
    {
        this.baseUrl = baseUrl;
    }

    public async save(data: ReportingData): Promise<any>
    {
        try
        {
            const response: AxiosResponse = await axios.post(this.baseUrl + "/api/reporting/save", data);
            return response.data;
        }
        catch (error)
        {
            // Handle errors here, you can log, throw, or return an error object.
            this.handleRequestError(error);
            throw error;
        }
    }

    private handleRequestError(error: AxiosError): void
    {
        if (error.response)
        {
            // The request was made, but the server responded with an error status code.
            console.error('Server responded with an error:', error.response.data);
        }
        else if (error.request)
        {
            // The request was made but no response was received, `error.request` is an instance of XMLHttpRequest.
            console.error('No response received:', error.request);
        }
        else
        {
            // Something happened in setting up the request that triggered an Error.
            console.error('Error:', error.message);
        }
    }
}